<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item style="line-height: 28px;">物料列表</el-breadcrumb-item>
      <el-breadcrumb-item v-if="showBtn==3||showBtn<1">
        <router-link to='addGoods'>
          <el-button size="mini" type="primary">添加物料</el-button>
        </router-link>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="">
        <el-upload
          v-if="showBtn==3||showBtn<1"
          class="upload-demo"
          :http-request="importGood"
          action=""
          :show-file-list="false">
          <el-button size="mini" type="primary">导入物料</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="" v-if="showBtn==3||showBtn<1">
        <el-button size="mini" type="primary" @click="downloadImportGood">导入物料示例</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button size="mini" type="primary" @click="exportGood">导出物料</el-button>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="时间">
        <el-date-picker
          v-model="sreachData.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setWeek">最近一周</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setMonth">最近一个月</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setThreeMonth">最近三个月</el-button>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="价格">
        <el-input-number v-model="sreachData.minMoney" controls-position="right" :precision="4" :step="0.1" :min="0"></el-input-number>
      </el-form-item>
      <span style="line-height:40px;margin:0 10px">-</span>
      <el-form-item label="">
        <el-input-number v-model="sreachData.maxMoney" controls-position="right" :precision="4" :step="0.1" :min="0"></el-input-number>
      </el-form-item>
      <!-- <el-form-item label="目录">
        <el-select v-model="sreachData.catalogId" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(v,k) in Cataloglist" :key="k" :label="v.title" :value="v.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="审核情况">
        <el-select v-model="sreachData.examine" placeholder="请选择">
          <el-option label="全部" value="-1"></el-option>
          <el-option label="待审核" value="0"></el-option>
          <el-option label="审核通过" value="1"></el-option>
          <el-option label="审核不通过" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="目录">
        <el-input v-model="sreachData.Catalog" placeholder="物料目录" style="width:300px">
        </el-input>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="供应商" v-if="showBtn==3||showBtn<1">
        <el-select v-model="sreachData.supplier" filterable clearable placeholder="请选择">
          <el-option label="全部" value="-1"></el-option>
          <el-option v-for="(val, key) in supplier" :key="key" :label="val.company" :value="val.companyid">{{val.company}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关键词">
        <el-input v-model="sreachData.words" placeholder="编码|名称|描述/规格|单位|税率" style="width:300px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="list">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      tooltip-effect="dark"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="gcode"
        label="物料号">
      </el-table-column>
      <el-table-column
        prop="title"
        label="物料名称">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="物料描述/规格">
      </el-table-column>
      <el-table-column
        prop="unit"
        width="110"
        label="单位">
      </el-table-column>
      <el-table-column
        prop="price"
        width="110"
        label="单价（含税）">
        <template slot-scope="scope">
          <p>￥{{scope.row.price}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="taxRate"
        width="110"
        label="税率">
      </el-table-column>
      <el-table-column
        width="200"
        label="价格有效时间">
        <template slot-scope="scope">
          <p>{{scope.row.validity_start_time}} - {{scope.row.validity_end_time}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        width="100"
        label="状态">
      </el-table-column>
      <el-table-column
        prop="company"
        width="110"
        label="供应商">
      </el-table-column>
      <el-table-column
        prop="sort"
        width="110"
        label="排序">
        <template slot-scope="scope">
          <el-input-number size="mini" style="width:100%" v-model="scope.row.sort" controls-position="right" @change="changeSort(scope.$index)" :min="0" :max="999"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="160">
        <template slot-scope="scope">
          <el-button v-if="showBtn!=1" size="mini" type="success" plain @click="editGoods(scope.row.id)">编辑</el-button>
          <el-button v-else size="mini" type="success" plain @click="editGoods(scope.row.id)">查看</el-button>
          <el-popconfirm
            confirm-button-text='好的'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            @confirm="delGoods(scope.row.id)" 
            title="确定删除物料吗？"
          >
            <el-button size="mini" type="danger" v-if="showBtn<1" plain slot="reference">删除</el-button>
          </el-popconfirm>
          
        </template>
      </el-table-column>
    </el-table>
    <p>
      <span style="float:left">
        <el-button  v-if="showBtn<1" @click="delGoods(0)">删除所选</el-button>
        <el-button type="primary" @click="examineAll(0)" v-if="showBtn<1">审核通过</el-button>
      </span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="sreachData.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="sreachData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </p>
  </div>
</el-card>
</template>
<script>
import userFunction from "@/api/user"
import goodsFunction from "@/api/goods"
  export default {
    data() {
      return {
        showBtn:sessionStorage.getItem('roleid'),
        Selectionids:[],
        tableData:[],
        total:0,
        supplier:[],
        Cataloglist:[],
        sreachData:{
          Catalog:'',
          catalogId:'',
          examine:'-1',
          statusName:'',
          limit:10,
          page:1,
          createTime:[],
          minMoney:'',
          maxMoney:'',
          supplier:'',
          cates:'',
          words:'',
          vcode:sessionStorage.getItem('token'),
        },
        form:{},
      };
    },
    methods: {
      setWeek(){
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.sreachData.createTime = [start,end]
      },
      setMonth(){
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        this.sreachData.createTime = [start,end]
      },
      setThreeMonth(){
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        this.sreachData.createTime = [start,end]
      },
      importGood(params){
        const file = params.file,form = new FormData();
        form.append("file", file)
        form.append("vcode", sessionStorage.getItem('token'));
        goodsFunction.importGood(form,this).then(res=>{
          this.list()
        })
      },
      exportGood(){
        goodsFunction.exportGood(this.sreachData,this).then(res=>{
          let a = document.createElement('a')
          a.href = res.filepath
          a.click()
        })
      },
      downloadImportGood(){
        let a = document.createElement('a')
          a.href = '/upload/导入物料示例.xlsx'
          a.click()
      },
      handleSizeChange(val){
        this.sreachData.limit = val
        this.list()
      },
      handleCurrentChange(val){
        this.sreachData.page = val
        this.list()
      },
      showChangeStatus(){
        this.changeStatusBox = true
      },
      editGoods(id){
        this.$router.push({path: '/home/editGoods',query: {id: id}})
      },
      delGoods(id){
        var data = [];
        if(id){
          data.push(id)
        }else{
          data = this.Selectionids
        }
        goodsFunction.delGoods({id:data,vcode:sessionStorage.getItem('token')},this).then(res=>{
          this.list()
        })
      },
      examineAll(id){
        var data = [];
        if(id){
          data.push(id)
        }else{
          data = this.Selectionids
        }
        goodsFunction.examineAll({id:data,vcode:sessionStorage.getItem('token')},this).then(res=>{
          this.list()
        })
      },
      handleSelectionChange(val) {
        this.Selectionids = []
        for(var i in val){
          this.Selectionids.push(val[i].id);
        }
      },
      changeSort(index){
        var data = this.tableData[index]
        goodsFunction.changeSort({sort:data.sort,id:data.id,vcode:sessionStorage.getItem('token')},this).then(res=>{
          
        })
      },
      list() {
        goodsFunction.list(this.sreachData,this).then(res=>{
          this.tableData = res.data
          this.total = res.total
        })
      },
      handleClick(tab) {
        this.sreachData.statusName = tab.name
        this.list()
      },
      getSupplier(){
        userFunction.getSupplier({vcode:sessionStorage.getItem('token'),isall:1},this).then((res) => {
          this.supplier = res
        })
      },
      // getCataloglist() {
      //   goodsFunction.Cataloglist({examine:-1,isall:1,vcode:sessionStorage.getItem('token')},this).then(res=>{
      //     this.Cataloglist = res
      //   })
      // },
    },
    mounted () {
      if(this.$route.query.catalogId){
        this.sreachData.catalogId = parseInt(this.$route.query.catalogId)
      }else{
        this.sreachData.catalogId = ''
      }
      
      // this.getCataloglist()
      this.list()
      if(this.showBtn<1||this.showBtn==3){
        this.getSupplier();
      }
    }
  };
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/goods/goodsList.vue